import { APIMethod, fetchData } from "@client";

export async function removeCompanyLogoQuery() {
  await fetchData("/company/logo", APIMethod.DELETE);
}
